import { render, staticRenderFns } from "./gantt.vue?vue&type=template&id=890d1e4e&scoped=true"
import script from "./gantt.vue?vue&type=script&lang=js"
export * from "./gantt.vue?vue&type=script&lang=js"
import style0 from "./gantt.vue?vue&type=style&index=0&id=890d1e4e&prod&lang=css"
import style1 from "./gantt.css?vue&type=style&index=1&id=890d1e4e&prod&scoped=true&lang=css&external"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "890d1e4e",
  null
  
)

export default component.exports